import React from 'react';
import Footer from '../../Footer/Footer';
import Navbar from '../../Home1/Navbar/Navbar';
import ContactHeader from '../ContactHeader/ContactHeader';
import ContactInfo from '../ContactInfo/ContactInfo';
import GMap from '../GMap/GMap';


const Contact = () => {
    return (
        <div className="ms-auto me-auto main-area">
            <Navbar/>
            <ContactHeader/>
            <GMap/>
            <ContactInfo/>
            <Footer/>
        </div>
    );
};

export default Contact;